export default {"src":"/_next/static/media/north-arrow-gray.3a461bce.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};